// Pending leave requests of EVERY type, on the Time Off dashboard (Muse R8,
// HO-0mvr6qa51001-d696cc). The dashboard's tabs are Annual / Sick / WFH only,
// so a pending Compassionate (or any other) request had nowhere to be seen or
// withdrawn from. This lists them by name and opens History on all types,
// where each row has the existing Withdraw / Cancel action.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate } from '@/lib/orgFormat';
import { useC } from '@/features/shared/theme/kaziColors';

type RawRequest = {
  id: string;
  status?: string;
  start_date?: string;
  end_date?: string;
  type?: string;
  leave_type?: { name?: string; type_code?: string } | null;
};

export const PendingRequestsCard: React.FC<{ requests: RawRequest[]; onOpen: () => void }> = ({ requests, onOpen }) => {
  const { t } = useTranslation('timeoff');
  const C = useC();
  const pending = requests.filter((r) => String(r.status || '').toLowerCase() === 'pending');
  if (pending.length === 0) return null;
  const range = (s?: string, e?: string) => (!s ? '' : !e || s === e ? formatDate(s) : `${formatDate(s)} – ${formatDate(e)}`);
  return (
    <div data-testid="pending-requests-card" style={{ border: `1px solid ${C.border}`, borderRadius: 12, padding: 16, marginBottom: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10, flexWrap: 'wrap' }}>
        <h3 style={{ fontSize: 14, fontWeight: 700, color: C.charcoal, flex: 1, margin: 0 }}>
          {t('pending_requests', { defaultValue: 'Pending requests ({{count}})', count: pending.length })}
        </h3>
        <button type="button" onClick={onOpen}
          style={{ padding: '8px 14px', borderRadius: 9, border: `1px solid ${C.border}`, background: 'transparent', color: C.orange, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
          {t('pending_review_withdraw', { defaultValue: 'Review or withdraw' })}
        </button>
      </div>
      <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'grid', gap: 6 }}>
        {pending.map((r) => (
          <li key={r.id} style={{ fontSize: 13, color: C.charcoalMid }}>
            <strong style={{ color: C.charcoal }}>{r.leave_type?.name || r.leave_type?.type_code || r.type || t('leave', { defaultValue: 'Leave' })}</strong>
            {' · '}{range(r.start_date, r.end_date)}
          </li>
        ))}
      </ul>
    </div>
  );
};
